import { Icon } from "@mui/material";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { convertDate } from "util/date";

export default function donationsTableData(
  donations,
  currentPage,
  perPageContent,
  onViewDetails
) {
  const formatAmount = (amount) => {
    return `$${parseFloat(amount).toFixed(2)}`;
  };

  const formatPaymentStatus = (status) => {
    const statusMap = {
      success: { label: "Success", color: "success" },
      failed: { label: "Failed", color: "error" },
      pending: { label: "Pending", color: "warning" },
    };
    return (
      statusMap[status?.toLowerCase()] || {
        label: status || "Unknown",
        color: "secondary",
      }
    );
  };

  return {
    columns: [
      { Header: "Sl.No", accessor: "slno", align: "center" },
      { Header: "Donor Name", accessor: "donorName", align: "left" },
      { Header: "Email / Phone", accessor: "contact", align: "left" },
      { Header: "Amount", accessor: "amount", align: "center" },
      {
        Header: "Payment ID / Transaction ID",
        accessor: "paymentId",
        align: "center",
      },
      // { Header: "Payment Status", accessor: "status", align: "center" },
      { Header: "Date & Time", accessor: "dateTime", align: "center" },
      { Header: "User Type", accessor: "userType", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: donations.map((donation, key) => {
      const statusInfo = formatPaymentStatus(donation?.payment_status);
      const donorName = `${donation?.first_name} ${donation?.last_name}`.trim();

      const contactInfo =
        donation?.email || donation?.phone
          ? donation.email || donation.phone || "N/A"
          : "N/A";
      const userType =
        donation?.user_id || donation?.user ? "Registered User" : "Guest User";

      return {
        slno: (
          <MDTypography
            component="a"
            variant="button"
            color="text"
            fontWeight="medium"
          >
            {(currentPage - 1) * perPageContent + key + 1}
          </MDTypography>
        ),
        donorName: (
          <MDTypography
            component="a"
            variant="button"
            color="text"
            fontWeight="medium"
          >
            {donorName}
          </MDTypography>
        ),
        contact: (
          <MDTypography
            component="a"
            variant="button"
            color="text"
            fontWeight="medium"
          >
            {contactInfo}
          </MDTypography>
        ),
        amount: (
          <MDTypography
            component="a"
            variant="button"
            color="text"
            fontWeight="medium"
          >
            {formatAmount(donation?.amount || 0)}
          </MDTypography>
        ),
        paymentId: (
          <MDTypography
            component="a"
            variant="button"
            color="text"
            fontWeight="medium"
            sx={{
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {donation?.payment_id ||
              donation?.transaction_id ||
              donation?.stripe_payment_id ||
              "N/A"}
          </MDTypography>
        ),
        // status: (
        //   <MDBox ml={-1}>
        //     <MDBadge
        //       badgeContent={statusInfo.label}
        //       color={statusInfo.color}
        //       variant="gradient"
        //       size="sm"
        //     />
        //   </MDBox>
        // ),
        dateTime: (
          <MDTypography
            component="a"
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {donation?.created_at ? convertDate(donation.created_at) : "N/A"}
          </MDTypography>
        ),
        userType: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={userType}
              color={userType === "Registered User" ? "info" : "secondary"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        actions: (
          <MDBox
            color="text"
            px={2}
            sx={{ cursor: "pointer" }}
            onClick={() => onViewDetails(donation)}
          >
            <Icon
              sx={{ fontWeight: "bold", color: "info.main" }}
              fontSize="small"
            >
              visibility
            </Icon>
          </MDBox>
        ),
      };
    }),
  };
}
